import { render, staticRenderFns } from "./BookingSeats.vue?vue&type=template&id=032799f0&scoped=true&"
import script from "./BookingSeats.vue?vue&type=script&lang=js&"
export * from "./BookingSeats.vue?vue&type=script&lang=js&"
import style0 from "./BookingSeats.vue?vue&type=style&index=0&id=032799f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032799f0",
  null
  
)

export default component.exports